import React, { FC, useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { Button, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { TABLE } from "../../constants";
import { format } from "../../functions";
import { Data } from "../../typescript/interfaces/context";

const useStyles = makeStyles((theme: Theme) => ({
  exportBtn: {
    height: "30px",
    backgroundColor: "#008AFC",
    width: "auto",
    paddingLeft: "0.7rem",
    paddingRight: "0.7rem",
  },
  link: {
    color: theme.palette.primary.contrastText,
    textTransform: "none",
    textDecoration: "none",
  },
}));

interface ExportCSVProps {
  data: Data[];
}

const ExportCSV: FC<ExportCSVProps> = ({ data }) => {
  const classes = useStyles();

  const [exportData, setExportData] = useState<Array<Data>>([]);

  useEffect(() => {
    if (data) {
      setExportData(data);
    }
  }, [data]);

  return (
    <Button variant="contained" size="small" className={classes.exportBtn}>
      <CSVLink
        headers={TABLE.EXPORT_HEADERS}
        data={format.dataForExport(exportData)}
        className={classes.link}
        filename={format.exportFileName()}
      >
        Export CSV
      </CSVLink>
    </Button>
  );
};

export default ExportCSV;
